import styled from 'styled-components';
import { margin, MarginProps, padding, PaddingProps } from 'styled-system';

export const SectionWrapper = styled.div<MarginProps & PaddingProps>`
  border-top: 1px solid ${({ theme }) => theme.colors.gray.extraLight};
  ${margin};
  ${padding};
`;
